module.exports = __webpack_public_path__ + "img/close.ecdc097e.png";